/*
Extension of the Backbone Collection to work better with Django-Tastypie

Based on http://paltman.com/2012/04/30/integration-backbonejs-tastypie/
*/
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';


export default Backbone.Collection.extend({
  params: {},

  initialize: function () {
    this.clear_params();
  },

  parse: function (response) {
    this.recent_meta = response.meta || {};
    return response.objects || response;
  },

  clear_params: function () {
    this.params = mobile ? _.extend({
      username: window.localStorage.getItem('USERNAME'),
      api_key: window.localStorage.getItem('API_KEY')
    }, AUTH) : {};
  },

  url: function () {
    var result = this.urlRoot;
    if (!_.isEmpty(this.params)) {
      result = result + ('?' + $.param(this.params));
    }
    return result;
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/screener-app/screener/static/js/screener/collections/tastypie.js
// module id = 22
// module chunks = 0